"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var Report = function Report($http, SERVER_URL) {
    "ngInject";

    return {
        getList: getList,
        put: put,
        postAdminComment: postAdminComment
    };

    function getList(page, offset, modelEnum) {
        var params = {
            page: page || 0,
            size: offset || 25,
            sort: "id,desc"
        };
        if (!!modelEnum) {
            params.modelEnum = modelEnum;
        }
        return $http.get(SERVER_URL + "/reports/by-model-enum", {
            params: params
        });
    }

    function put(report) {
        return $http.put(SERVER_URL + "/reports", report);
    }

    function postAdminComment(adminComment) {
        return $http.post(SERVER_URL + "/admin-comments", adminComment);
    }
};
exports.default = Report;


// WEBPACK FOOTER //
// ./client/app/services/reportService/report.service.js